import { mutatorAction } from "satcheljs";
import { getStore } from "../store/store";
import type { Win32IconSize } from "../store/schema/Win32IconStore";

export const setWin32IconSizeRegisteredMutator: (iconSize: Win32IconSize) => void = mutatorAction("setWin32IconSizeRegistered", (iconSize: Win32IconSize) => {
    switch (iconSize) {
        case 16:
            getStore().areSmallIconsRegistered = true;
            break;
        case 20:
            getStore().areDefaultIconsRegistered = true;
            break;
        case 32:
            getStore().areLargeIconsRegistered = true;
            break;
    }
});
